import { useEffect, useRef, useState } from "react";
import { availableLanguages, useLanguage } from "../context/LanguageContext";

const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isOpen && containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleToggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelectLanguage = (value: typeof availableLanguages[number]["value"]) => {
    setLanguage(value);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher" ref={containerRef}>
      <button
        type="button"
        className="language-switcher__button"
        aria-haspopup="true"
        aria-expanded={isOpen}
        onClick={handleToggleMenu}
        title={t("common.language")}
      >
        <span className="language-switcher__icon" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M2 12h20" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
        </span>
        <span className="language-switcher__label">{language.toUpperCase()}</span>
      </button>
      {isOpen && (
        <div className="language-switcher__menu" role="menu">
          {availableLanguages.map((lang) => (
            <button
              type="button"
              key={lang.value}
              className={`language-switcher__menu-item${lang.value === language ? " is-active" : ""}`}
              role="menuitemradio"
              aria-checked={lang.value === language}
              onClick={() => handleSelectLanguage(lang.value)}
            >
              {t(lang.labelKey)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
